var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "rich-main-class",
      style: _vm.autoStyle,
      on: { dblclick: _vm.setEdit },
    },
    [
      _vm.editShow
        ? _c("Editor", {
            staticStyle: { width: "100%", height: "100%" },
            attrs: {
              id: _vm.tinymceId,
              init: _vm.init,
              disabled: !_vm.canEdit,
            },
            on: { onClick: _vm.onClick },
            model: {
              value: _vm.myValue,
              callback: function ($$v) {
                _vm.myValue = $$v
              },
              expression: "myValue",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }